<template>
  <div class="store-manage-page">
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">商品类型管理</h2>
        <p class="page-desc">管理商品分类，支持多级分类与排序</p>
      </div>
      <el-button icon="el-icon-plus" type="primary" @click="onShowSave('新增',undefined,0)">新增类型</el-button>
    </div>

    <div class="manage-card">
      <el-tabs v-model="stateValue" class="manage-tabs" @tab-click="tabClick">
        <el-tab-pane v-for="(state,j) in status" :key="j" :label="state" :name="state"/>
      </el-tabs>

      <div class="store-manage-page__table">
        <el-table v-loading="loadTable" :data="records" stripe row-key="id"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}" size="small">
          <el-table-column fixed label="ID" prop="id" width="80"/>
          <el-table-column label="类型名" prop="name" min-width="150" show-overflow-tooltip/>
          <el-table-column align="center" label="状态" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.state === '上' ? 'success' : 'info'" effect="light" size="mini">
                {{ row.state === '上' ? '上架' : '下架' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" prop="createdTime" show-overflow-tooltip/>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="{ row }">
              <div class="row-actions">
                <el-button size="mini" type="text" @click="onShowSave('修改',row)">编辑</el-button>
                <el-button v-if="row.parentId===0" size="mini" type="text" @click="onShowSave('新增二级',undefined,row.id)">新增二级</el-button>
                <el-button v-else size="mini" type="text" @click="toProduct(row)">商品管理</el-button>
                <el-dropdown trigger="click" @command="cmd => handleRowCommand(cmd, row)">
                  <el-button size="mini" type="text">
                    更多<i class="el-icon-arrow-down el-icon--right"/>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="moveUp" :disabled="!isUp(row)">上移</el-dropdown-item>
                    <el-dropdown-item command="moveDown" :disabled="!isDown(row)">下移</el-dropdown-item>
                    <el-dropdown-item v-if="row.state==='下'" command="shelfUp" divided>上架</el-dropdown-item>
                    <el-dropdown-item v-if="row.state==='上'" command="shelfDown">下架</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-footer">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>

    <!--  保存  -->
    <el-dialog
        :title="title"
        :visible.sync="showSave"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="save" ref="ruleForm">
        <el-form-item label="类型名" prop="name"
                      :rules="[
                        {required: true, message: '请输入类型名', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="save.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="标题颜色" prop="titleColor"
                      :rules="[
                        {required: true, message: '请选择标题颜色', trigger: 'blur'}
                        ]">
          <div class="block">
            <el-color-picker v-model="save.titleColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="封面" prop="coverImg" v-if="save.parentId!==0"
                      :rules="[
                        {required: true, message: '请上传封面', trigger: 'blur'},
                        ]">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                accept="image/*"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
            >
              <img v-if="save.coverImg" :src="save.coverImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="圆角(%)" prop="borderRadius" v-if="save.parentId!==0"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLtNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="save.borderRadius" type="number"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSave = false">取 消</el-button>
        <el-button type="primary" @click="doSave('ruleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!--  上下架  -->
    <el-dialog
        title="提示"
        :visible.sync="showChangeState"
        width="30%"
        center>
      <div style="align-content: center">您确认要{{changeState.state=='上'?'上架':'下架'}}ID为 {{changeState.id}} 吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChangeState = false">取 消</el-button>
        <el-button type="primary" @click="doChangeState">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
        title="提示"
        :visible.sync="showDel"
        width="30%"
        center>
      <div style="align-content: center">您确认要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="doDel">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import save from "@/api/store/StoreType/save";
import {Message} from "element-ui";
import StoreTypePage from "@/api/store/StoreType/page";
import remove from "@/api/store/StoreType/remove";
import swapOrder from "@/api/store/StoreType/swapOrder";
import changeState from "@/api/store/StoreType/changeState";
import Page from "@/components/Page.vue";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";
import {notLtNum0} from "@/utils/check";

export default {
  name: "StoreTypeManage",
  components: {Page},
  data() {
    return {
      current:1,
      size:10,
      total: 0,
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData:{},
      params: {},
      loadTable: false,
      records: [],

      storeShopId: localStorage.getItem("storeShopId"),

      status:['上架','下架','全部'],
      stateValue:'上架',
      state:'上',

      showSave:false,
      title:undefined,
      save:{
        coverImg: undefined
      },

      showChangeState:false,
      changeState:{},

      delId: undefined,
      showDel: false,

      parents: new Map(),

    }
  },
  methods: {
    notLtNum0,
    // 处理行命令
    handleRowCommand(command, row) {
      switch (command) {
        case 'moveUp':
          this.move(row, true)
          break
        case 'moveDown':
          this.move(row, false)
          break
        case 'shelfUp':
          this.onChangeState(row, '上')
          break
        case 'shelfDown':
          this.onChangeState(row, '下')
          break
      }
    },
    tabClick(){
      if(this.stateValue==='上架'){
        this.state='上'
      }
      if(this.stateValue==='下架'){
        this.state='下'
      }
      if(this.stateValue==='全部'){
        this.state=undefined
      }

      this.reset()
    },
    toProduct(row){
      localStorage.setItem("storeTypeId",row.id)
      this.$router.push({
        name: "商品管理",
      })
    },
    doChangeState(){
      changeState(this.changeState.id, this.changeState.state).then(res=>{
        if(res.code===1){
          Message({
            message:"成功",
            type:"success",
            duration:3000
          })
          this.showChangeState = false
          this.fetchData()
        }else{
          if(res.data && res.data.illError){
            Message({
              message: res.data.illError,
              type: "error",
              duration:3000
            })
          }else{
            Message({
              message: res.msg,
              type: "error",
              duration:3000
            })
          }
        }
      })
    },
    onChangeState(row,state){
      // if(state==='上'){
      //   if(this.parents.has(row.parentId)){
      //     let parent = this.parents.get(row.parentId)
      //     if(parent.state==='下'){
      //       return Message({message:'请先上架一级类型',type:'error',duration:3000})
      //     }
      //   }
      // }
      this.changeState.id=row.id
      this.changeState.state=state
      this.showChangeState = true
    },
    move(row,isUp){
      swapOrder(row.id,isUp).then(res=>{
        if(res.code===1){
          Message({
            message: '成功',
            type: 'success',
            duration: 3 * 1000
          });
          this.fetchData()
        }
      })
    },
    // move(row, type) {
    //   //查询需要交换位置的两个id和order
    //   let swap = undefined
    //   let records = undefined
    //   if(row.parentId===0){
    //     records = this.records
    //   }else{
    //     records = this.parents.get(row.parentId).children
    //   }
    //
    //   let j = undefined
    //   for (let i = 0; i < records.length; i++) {
    //     if (records[i].id === row.id) {
    //       j = i
    //     }
    //   }
    //   if (type === '上') {
    //     swap = records[j - 1]
    //   } else {
    //     swap = records[j + 1]
    //   }
    //
    //   let a = {
    //     id: row.id,
    //     order: row.order,
    //   }
    //   let b = {
    //     id: swap.id,
    //     order: swap.order,
    //   }
    //
    //   swapOrder([a,b]).then(res=>{
    //     if(res.code==1){
    //       Message({
    //         message: '成功',
    //         type: 'success',
    //         duration: 3 * 1000
    //       });
    //       this.fetchData()
    //     }
    //   })
    // },
    isUp(row){
      if(row.parentId==0){
        return row.id!=this.records[0].id
      }else{
        return row.id!=this.parents.get(row.parentId).children[0].id
      }
    },
    isDown(row){
      if(row.parentId==0){
        return row.id!=this.records[this.records.length-1].id
      }else{
        let records = this.parents.get(row.parentId).children
        return row.id!=records[records.length-1].id
      }
    },
    doDel(){
      let that = this
      remove(this.delId).then(res=>{
        if(res.code!=1){
          Message({
            message: '删除失败',
            type: 'error',
            duration: 3 * 1000
          });
        }else {
          Message({
            message: '删除成功',
            type: 'success',
            duration: 3 * 1000
          });
          that.showDel = false
          that.fetchData()
        }
      })
    },
    onShowDel(row){
      this.delId = row.id
      this.showDel = true
    },
    doSave(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.save))
          if(params.parentId!==0){
            params.coverImg=params.coverImg.split('?')[0].substring(this.fileBaseUrl.length+1)
          }
          save(params).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showSave=false
              this.fetchData()
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowSave(title,row,parentId){
      this.title=title
      this.save={
        titleColor: '#000000',
        coverImg: undefined,
        borderRadius:0,
        parentId:parentId,
        shopId:this.storeShopId,
      }
      if(row){
        this.save=JSON.parse(JSON.stringify(row))
        if(row.parentId!==0){
          this.save.coverImg=this.fileBaseUrl+this.save.coverImg
        }
      }
      this.showSave=true
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    async beforeUpload(){
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData = resultObj;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
      });
      return true
    },
    //文件上传成功回调
    handleSuccess(response, file){
      //上传的完整的文件地址
      var urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}",file.name) ;
      let filepath = urlPath.substring(this.fileBaseUrl.length+1)
      adminGetFileSignUrl(filepath).then(res=>{
        this.save.coverImg=res.data
      })
    },
    getStoreType(){
      if(this.state) {
        this.params.state = this.state
      }
      this.params.shopId=this.storeShopId
      StoreTypePage(this.current,this.size,this.params).then(res=>{
        let data = res.data.data
        data.sort((a,b)=>a.order-b.order)
        let records = []
        let parents = new Map()
        for(let i=0;i<data.length;i++){
          let e = data[i]
          if(e.parentId===0){
            e.children=[]
            records.push(e)
            parents.set(e.id,e)
          }
        }
        for(let i=0;i<data.length;i++){
          let e = data[i]
          if(e.parentId>0){
            let children = parents.get(e.parentId).children
            children.push(e)
          }
        }
        this.records=records
        this.parents=parents
        this.total=res.data.total
      })
    },
    search(){
      this.fetchData()
    },
    reset(){
      this.current=1
      this.params = {}
      this.fetchData()
    },
    fetchData(){
      this.getStoreType()
    },
  },

  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
.store-manage-page {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  background: #f5f7fa;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 4px;

  &__info {
    flex: 1;
  }
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.manage-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.manage-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

.store-manage-page__table {
  padding: 0 20px;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.table-footer {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}

@media (max-width: 768px) {
  .store-manage-page {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .store-manage-page__table {
    padding: 0 12px;
  }
}
</style>
